import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import { FormControl, Select, TextField, MenuItem } from "@mui/material"
import { useEffect, useState } from "react"
import { helpUpdateTypeUserofOrganization } from "../../../../../app/services/Organization/helpUpdateTypeUserOrganization"

import { useDispatch } from "react-redux"
import { v4 as uuidv4 } from "uuid"
import { logEvent } from "../../../../../utils/LogEvents"
import { getSubscriberStatusCorpEntities } from "../../../../../app/services/Suscriber/getSubscriberStatusCorpEntities"
import { namesTypesTraduc } from "../../../../../utils/traducTypes"
import {
  setErrorTextSnackBar,
  setRequestTextSnackBar,
  setSuccessTextSnackBar,
} from "../../../../../redux/actions/app"
import useStylesEditUserOfOrganization from "./Styles/useStyleEditUserOfOrganization"
import { useNavigate } from "react-router-dom"
import { helpUpdateUserofOrganizationLoginAccount } from "../../../../../app/services/LoginAccount/UpdateUserInfo"

export default function StepperEditUserOfOrganization({
  setEditUserOfOrganization,
  setLoading,
  item,
  setRows,
  types,
  typesComercial,
}) {
  const dispatch = useDispatch()
  const classes = useStylesEditUserOfOrganization()
  const [typesStatus, settypesStatus] = useState(null)

  const navigate = useNavigate()
  const refreshPage = () => {
    navigate(0)
  }

  // traduc types in spanish
  const traducSpanishTypes = (type) => {
    const nameTraduc = namesTypesTraduc.filter((item) => item.code === type)
    return nameTraduc[0].name
  }
  // get name of type user code
  const handleGetNameTraducType = (code) => {
    const result = types.filter((t) => t.organizationUserTypeCode === code)
    return result[0].organizationUserTypeCode
  }

  const codeStatesEnabled = ["ACTIVE", "DELETED", "WAITING_VALIDATION"]
  const codeTypesEnabled = ["ORG-STAFF", "ORG-ADMIN"]
  const codeStatesAccountEnabled = ["ACTIVE"]

  // get name of type user comercial code
  const handleGetNameTraducTypeComercial = (code) => {
    const result = typesComercial?.filter(
      (t) => t.organizationCommercialUserTypeId === code,
    )
    return result[0].organizationCommercialUserTypeName
  }
  // get name of status user code
  const handleGetNameStatus = (code) => {
    const result = typesStatus.filter((t) => t.subscriber_status_id === code)
    return result[0].subscriber_status_desc
  }

  // hooks for inputs
  const [name, setname] = useState(item.login_account.first_name || "")
  const [lastName, setlastName] = useState(item.login_account.last_name || "")
  const [phone, setphone] = useState("Desactivado")
  // hooks set types actives of user
  const [type, settype] = useState(
    handleGetNameTraducType(
      item.organization_user_type.organization_user_type_code,
    ),
  )

  const [typeComercial, setTypeComercial] = useState(
    handleGetNameTraducTypeComercial(item.organization_commercial_user_type_id),
  )
  const [status, setStatus] = useState("")

  useEffect(async () => {
    const response = await getSubscriberStatusCorpEntities()
    settypesStatus(response.data)
  }, [])

  useEffect(() => {
    if (typesStatus) {
      setStatus(handleGetNameStatus(item.user_status_id))
    }
  }, [typesStatus])

  // change inputs
  const handleChangeName = (event) => {
    setname(event.target.value)
  }
  const handleChangeLastname = (event) => {
    setlastName(event.target.value)
  }
  const handleChangePhone = (event) => {
    setphone(event.target.value)
  }
  const handleChangeType = (event) => {
    settype(event.target.value)
  }
  const handleChangeTypeComercial = (event) => {
    setTypeComercial(event.target.value)
  }
  const handleChangeStatus = (event) => {
    setStatus(event.target.value)
  }

  // filter types not type select and not derived
  // const typesfilter = types.filter((t) => t.organizationUserTypeId !== 2)
  // finish proccess by error request
  const requestFailure = (text) => {
    // error
    dispatch(setRequestTextSnackBar())
    dispatch(setErrorTextSnackBar(text))
    setLoading(false)
  }
  // update user loginaccount request
  const updateLoginAccount = async (conditions, transactionId) => {
    try {
      const response = await helpUpdateUserofOrganizationLoginAccount(
        conditions,
      )
      await logEvent(
        "CGI - loginAccountUpdate",
        { body: conditions, response: response },
        transactionId,
      )
    } catch (err) {
      await logEvent(
        "CGI - loginAccountUpdate",
        { body: conditions, error: err },
        transactionId,
      )
      requestFailure("Ocurrió un error. Intente nuevamente.")
      return "error"
    }
  }
  // update type of user request
  const updateTypeUserRequest = async (user, transactionId) => {
    try {
      await helpUpdateTypeUserofOrganization(user)
      await logEvent(
        "CGI - updateUserOrganizationCorpEntities",
        user,
        transactionId,
      )
    } catch (err) {
      await logEvent(
        "CGI - updateUserOrganizationCorpEntities",
        { body: user, error: err },
        transactionId,
      )
      requestFailure("Ocurrió un error. Intente nuevamente.")

      return "error"
    }
  }
  // edit name and lastname proccess
  const handleEditUserToLoginAccount = async (transactionId) => {
    const conditions = {}
    if (name !== item.login_account?.first_name) {
      conditions.firstName = name
    }
    if (lastName !== item.login_account?.last_name) {
      conditions.lastName = lastName
    }

    if (conditions.firstName || conditions.lastName) {
      conditions.loginAccountId = item.login_account_id
      return await updateLoginAccount(conditions, transactionId)
    }
  }

  // handle Edit user process global
  const handleEditUser = async () => {
    setLoading(true)
    // transaction id for Login events
    const transactionId = uuidv4()
    // name or lastname change
    const response = await handleEditUserToLoginAccount(transactionId)

    if (response === "error") {
      return
    }
    const user = {}
    // type user change
    if (type !== item.organization_user_type.organization_user_type_code) {
      const typeResult = types.filter(
        (t) => t.organizationUserTypeCode === type,
      )
      user.organizationUserTypeCode = typeResult[0].organizationUserTypeCode
    }
    // type comercial user change
    if (typeComercial !== item.organization_commercial_user_type_id) {
      const typecomercialResult = typesComercial.filter(
        (t) =>
          handleGetNameTraducTypeComercial(
            t.organizationCommercialUserTypeId,
          ) === typeComercial,
      )
      user.organizationCommercialUserTypeCode =
        typecomercialResult[0].organizationCommercialUserTypeCode
    }
    if (status !== handleGetNameStatus(item.user_status_id)) {
      const statusResult = typesStatus.filter(
        (item) => item.subscriber_status_desc === status,
      )
      user.userStatusCode = statusResult[0].subscriber_status_code
    }
    if (
      user.organizationUserTypeCode ||
      user.organizationCommercialUserTypeCode ||
      user.userStatusCode
    ) {
      user.organizationUserId = item.user_id

      const updateTypeUser = await updateTypeUserRequest(user, transactionId)
      if (updateTypeUser === " error") {
        return
      }
      dispatch(setRequestTextSnackBar())
      dispatch(setSuccessTextSnackBar("Usuario editado con éxito."))

      setEditUserOfOrganization(false)
      setLoading(false)
      setTimeout(() => {
        refreshPage()
      }, 1000)
    }
  }
  return (
    <>
      <Box className={classes.mainBox}>
        <Box className={classes.containBox}>
          <Box sx={{ paddingLeft: 2 }}>
            <Typography className={classes.editUserTypography}>
              Editar el usuario:
            </Typography>

            <Typography className={classes.instructionsTypography}>
              Edite solo los campos que desea modificar
            </Typography>
            <Typography className={classes.fieldsTypography}>
              Nombre:
            </Typography>

            <TextField
              id="username"
              variant="outlined"
              size="small"
              name="name"
              value={name}
              onChange={handleChangeName}
              className={classes.inputFields}
            />
            <Typography className={classes.fieldsTypography}>
              Apellido:
            </Typography>

            <TextField
              id="username"
              variant="outlined"
              size="small"
              name="lastname"
              value={lastName}
              onChange={handleChangeLastname}
              className={classes.inputFields}
            />
            <Typography className={classes.fieldsTypography}>
              Telefono:
            </Typography>

            <TextField
              id="username"
              variant="outlined"
              size="small"
              name="number"
              disabled
              value={phone}
              onChange={handleChangePhone}
              className={classes.inputFields}
            />

            <Typography className={classes.fieldsTypography}>
              Tipo de usuario:
            </Typography>
            <FormControl variant="standard" className={classes.inputFields}>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled"
                value={type}
                onChange={handleChangeType}
                size="small"
              >
                {types ? (
                  types.map((t) => (
                    <MenuItem
                      key={t.organizationUserTypeCode}
                      value={t.organizationUserTypeCode}
                      disabled={
                        !codeTypesEnabled.includes(
                          t.organizationUserTypeCode,
                        ) ||
                        !codeTypesEnabled.includes(
                          item.organization_user_type
                            .organization_user_type_code,
                        )
                      }
                    >
                      {traducSpanishTypes(t.organizationUserTypeCode)}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">
                    No se encontraron tipos de usuarios
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            <Typography className={classes.fieldsTypography}>
              Tipo comercial:
            </Typography>
            <FormControl variant="standard" className={classes.inputFields}>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled2"
                value={typeComercial}
                onChange={handleChangeTypeComercial}
                size="small"
              >
                {typesComercial ? (
                  typesComercial.map((t) => (
                    <MenuItem
                      key={t.organizationCommercialUserTypeName}
                      value={t.organizationCommercialUserTypeName}
                    >
                      {t.organizationCommercialUserTypeName}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">
                    No se encontraron tipos comerciales
                  </MenuItem>
                )}
              </Select>
            </FormControl>

            <Typography className={classes.fieldsTypography}>
              Estado:
            </Typography>
            <FormControl variant="standard" className={classes.inputFields}>
              <Select
                labelId="demo-simple-select-filled-label"
                id="demo-simple-select-filled3"
                value={status}
                onChange={handleChangeStatus}
                size="small"
              >
                {typesStatus ? (
                  typesStatus.map((t) => (
                    <MenuItem
                      key={t.subscriber_status_desc}
                      value={t.subscriber_status_desc}
                    >
                      {t.subscriber_status_desc}
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem value="">No se encontraron estados</MenuItem>
                )}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Box className={classes.boxButton}>
          <Box
            className={classes.butons}
            sx={{
              "&:hover": {
                bgcolor: "#1BF57F",
              },
            }}
          >
            <Typography
              onClick={() => {
                handleEditUser()
              }}
              className={classes.editTypography}
            >
              Editar
            </Typography>
          </Box>
          <ButtonClose setEditUserOfOrganization={setEditUserOfOrganization} />
        </Box>
      </Box>
    </>
  )
}

function ButtonClose({ setEditUserOfOrganization }) {
  const classes = useStylesEditUserOfOrganization()
  return (
    <Box className={classes.cancelButton}>
      <Box className={classes.cancelButtonStyle}>
        <Typography
          onClick={() => {
            setEditUserOfOrganization(false)
          }}
          className={classes.cancelButtonTypography}
        >
          Cancelar
        </Typography>
      </Box>
    </Box>
  )
}
